/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { ReactComponent as DragDropIcon } from "icons/drag-drop-icon.svg";
import {
  taskTypes,
  taskConfigs,
  getContentClasses,
} from "components/Task/constants";

const Task = ({ type, args }) => {
  const taskClass = type.replace(new RegExp("-", "g"), "_");
  const contentClasses = getContentClasses(type, args);

  return (
    <div
      className={`task ${taskClass}`}
      onClick={() => taskConfigs[type].onClick(args)}
      data-testid="vt-task"
    >
      <div className={`task__task_content ${contentClasses}`}>
        <span className="task__task_content__drag_icon">
          <DragDropIcon />
        </span>
        <span className="task__task_content__icon">
          {taskConfigs[type].icon}
        </span>
        <span className="task__task_content__title">
          {taskConfigs[type].title}
        </span>
        <span className="task__task_content__description">
          {taskConfigs[type].description}
        </span>
        <div className="task__task_content__button">
          <Button
            variant={buttonVariants.secondary}
            onClick={() => {}}
            content={taskConfigs[type].buttonTitle}
          />
        </div>
      </div>
    </div>
  );
};

Task.propTypes = {
  type: PropTypes.string.isRequired,
  args: PropTypes.oneOfType([PropTypes.object]),
};

export default Task;
export { taskTypes, taskConfigs };
